document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector(".store-collections-carousel");
  if (!carousel) return;

  const sliderContainer = carousel.querySelector(
    ".store-collections-carousel__slider-container"
  );
  const slider = carousel.querySelector(".store-collections-carousel__slider");
  const cards = carousel.querySelectorAll(".store-collections-carousel__card");
  const paginationDots = carousel.querySelectorAll(
    ".store-collections-carousel__pagination-dot"
  );
  const prevButton = carousel.querySelector(".slider-btn.left");
  const nextButton = carousel.querySelector(".slider-btn.right");

  if (!slider || cards.length === 0) return;

  let currentIndex = 0;
  let isDragging = false;
  let startPosX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;
  let animationID = 0;
  let sliderWidth = sliderContainer.offsetWidth;
  let cardWidth = cards[0].offsetWidth;
  let visibleCards = Math.round(sliderWidth / cardWidth);
  let isTouchDevice = "ontouchstart" in window;
  const cardsCount = cards.length;

  // Update navigation state
  const updateNavigation = () => {
    if (currentIndex === 0) {
      prevButton.classList.add("hide");
      nextButton.classList.remove("hide");
    } else if (currentIndex >= cards.length - visibleCards) {
      nextButton.classList.add("hide");
      prevButton.classList.remove("hide");
    } else {
      prevButton.classList.remove("hide");
      nextButton.classList.remove("hide");
    }

    paginationDots.forEach((dot, index) => {
      dot.setAttribute(
        "aria-current",
        index === currentIndex ? "true" : "false"
      );
    });

    if (cardsCount > visibleCards) {
      let dotsToShow = cardsCount + 1 - visibleCards;
      paginationDots.forEach((dot, index) => {
        if (index < dotsToShow) {
          dot.style.display = "block";
        } else {
          dot.style.display = "none";
        }
      });
    } else {
      paginationDots.forEach((dot) => {
        dot.style.display = "none";
      });
      prevButton.classList.add("hide");
      nextButton.classList.add("hide");
    }
  };

  // Set slider position with transform
  const setSliderPosition = () => {
    slider.style.transform = `translateX(${currentTranslate}px)`;
  };

  // Calculate current index based on position
  const setPositionByIndex = () => {
    if (currentIndex < 0) currentIndex = 0;
    currentTranslate = -currentIndex * cardWidth;
    prevTranslate = currentTranslate;
    setSliderPosition();
  };

  // Scroll to specific index
  const scrollToIndex = (index) => {
    currentIndex = Math.max(0, Math.min(index, cards.length - visibleCards));
    setPositionByIndex();
    updateNavigation();
  };

  // Animation for smooth dragging
  const animation = () => {
    // Apply limits to dragging
    const maxTranslate = 0;
    const minTranslate = -(cards.length - visibleCards) * cardWidth;
    currentTranslate = Math.max(
      minTranslate,
      Math.min(maxTranslate, currentTranslate)
    );

    setSliderPosition();
    if (isDragging) requestAnimationFrame(animation);
  };

  // Touch events only
  const touchStart = (event) => {
    if (window.innerWidth >= 1000 || !isTouchDevice) return;

    isDragging = true;
    startPosX = event.touches[0].clientX;
    slider.style.transition = "none";
    animationID = requestAnimationFrame(animation);
  };

  const touchMove = (event) => {
    if (!isDragging || window.innerWidth >= 1000 || !isTouchDevice) return;

    const currentPosition = event.touches[0].clientX;
    currentTranslate = prevTranslate + currentPosition - startPosX;
  };

  const touchEnd = () => {
    if (window.innerWidth >= 1000 || !isTouchDevice) return;

    isDragging = false;
    cancelAnimationFrame(animationID);
    slider.style.transition = "transform 0.3s ease-out";

    const movedBy = currentTranslate - prevTranslate;

    if (movedBy < -50 && currentIndex < cards.length - visibleCards) {
      currentIndex += 1;
    } else if (movedBy > 50 && currentIndex > 0) {
      currentIndex -= 1;
    }

    setPositionByIndex();
    updateNavigation();
  };

  // Add touch event listeners only for touch devices
  if (isTouchDevice) {
    sliderContainer.addEventListener("touchstart", touchStart, {
      passive: true,
    });
    sliderContainer.addEventListener("touchmove", touchMove, {
      passive: false,
    });
    sliderContainer.addEventListener("touchend", touchEnd, { passive: true });
  }

  // Navigation controls
  prevButton.addEventListener("click", () => scrollToIndex(currentIndex - 1));
  nextButton.addEventListener("click", () => scrollToIndex(currentIndex + 1));

  paginationDots.forEach((dot, index) => {
    dot.addEventListener("click", () => scrollToIndex(index));
  });

  // Handle resize

  let resizeTimeout;
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      sliderWidth = sliderContainer.offsetWidth;
      cardWidth = cards[0].offsetWidth;
      visibleCards = Math.round(sliderWidth / cardWidth);
      currentIndex = Math.min(currentIndex, cards.length - visibleCards);
      setPositionByIndex();
      updateNavigation();

      if (window.innerWidth >= 1000) {
        slider.style.transform = "none";
      }
    }, 100); // Executes once after 100ms of resize end
  };
  window.addEventListener("resize", handleResize);

  // Initialize
  updateNavigation();
});
